import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CELL_SETS_ERROR, CELL_SETS_CLUSTERING_UPDATING } from 'redux/actionTypes/cellSets';
import getTimeoutForWorkerTask from 'utils/getTimeoutForWorkerTask';
import fetchWork from 'utils/work/fetchWork';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import updateCellSetsClustering from 'redux/actions/cellSets/updateCellSetsClustering';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
var runCellSetsAnnotation = function runCellSetsAnnotation(experimentId, species, tissue) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets, error, updatingClustering, loading, body, timeout, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getCellSets = getCellSets()(getState().cellSets), error = _getCellSets.error, updatingClustering = _getCellSets.updatingClustering, loading = _getCellSets.loading;
              if (!(loading && updatingClustering || error || experimentId === 'c26b1fc8-e207-4a45-90ae-51b730617bee')) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              body = {
                name: 'ScTypeAnnotate',
                species: species,
                tissue: tissue
              };
              dispatch({
                type: CELL_SETS_CLUSTERING_UPDATING
              });
              timeout = getTimeoutForWorkerTask(getState(), 'ClusterCells');
              _context.prev = 6;
              _context.next = 9;
              return fetchWork(experimentId, body, getState, dispatch, {
                timeout: timeout,
                broadcast: true
              });
            case 9:
              _context.next = 16;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](6);
              _errorMessage = handleError(_context.t0, endUserMessages.ERROR_CELL_SETS_ANNOTATION_FAILED);
              dispatch({
                type: CELL_SETS_ERROR,
                payload: {
                  experimentId: experimentId,
                  error: _errorMessage
                }
              });
              // To set the clustering status back to false
              dispatch(updateCellSetsClustering(experimentId));
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 11]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default runCellSetsAnnotation;